"use strict";
const OVERLAY_STYLES = {
    zsm: () => ({
        color: "#e74500",
        fillColor: "#e74500",
        fillOpacity: 0.1,
        weight: 3,
        opacity: 1
    }),

    zone_orsec: () => ({
        color: "white",
        dashArray: "5, 10",
        fillColor: "#fca7a7",
        fillOpacity: 0.6,
        weight: 4,
        opacity: 1
    }),

    zone: () => ({
        color: "yellow",
        dashArray: "5, 10",
        fillColor: "#debf81",
        fillOpacity: 0.6,
        weight: 4,
        opacity: 1
    }),

    zone_recherche: () => ({
        color: "yellow",
        dashArray: "5, 10",
        fillColor: "#86aceb",
        fillOpacity: 0.6,
        weight: 4,
        opacity: 1
    }),

    zone_calcul: () => ({
        color: "red",
        dashArray: "10, 10",
        fillColor: "#86aceb",
        fillOpacity: 0.2,
        weight: 4,
        opacity: 1
    }),

    zone_environnement: () => ({
        color: "red",
        dashArray: "5, 10",
        fillColor: "#008000",
        fillOpacity: 0.6,
        weight: 4,
        opacity: 1
    }),

    zone_air: () => ({
        color: "red",
        dashArray: "5, 10",
        fillColor: "#B31B1B",
        fillOpacity: 0.6,
        weight: 4,
        opacity: 1
    }),

    zone_flux: () => ({
        color: "#472714",
        dashArray: "5, 10",
        fillColor: "#96542d",
        fillOpacity: 0.6,
        weight: 2,
        opacity: 1
    }),

    itineraire: () => ({
        color: "#472714",
        dashArray: "20, 40",
        weight: 5,
        opacity: 1
    }),

    highline: (properties = {}) => [false, 0, "false", "0", "non"].includes(properties.active)
        ? { color: "#808080", weight: 4, opacity: 1 }
        : { color: "#ff00ff", weight: 4, opacity: 1 },

    line: () => ({
        color: "#ff0000",
        weight: 3,
        opacity: 1
    }),

    trace: () => ({
        color: "#e74500",
        weight: 3,
        opacity: 1
    }),

    catex: () => ({
        color: "#FF7518",
        weight: 4,
        opacity: 1
    }),
    air_obstacle: () => ({ color: "#e74500", weight: 4, opacity: 1 }),
    cable: () => ({
        color: "#e74500",
        weight: 4,
        opacity: 1
    }),
    enedis: () => ({
        color: "#ff2c2c",
        weight: 3,
        opacity: 1
    }),

    piste_vtt: (properties = {}) => ({
        color: properties.color || "yellow",
        weight: 4,
        opacity: 1
    }),

    acces_vsav: () => ({
        color: "#FFA500",
        dashArray: "15, 10",
        weight: 3,
        opacity: 1
    }),

    acces_vltt: () => ({
        color: "yellow",
        dashArray: "15, 10",
        weight: 3,
        opacity: 1
    })
};

export default OVERLAY_STYLES;
